module.exports = __webpack_public_path__ + "static/media/on-platinum.3364e1ff.png";